<div>
  <button
    mat-flat-button
    name="addSer"
    class="Icon-Btn"
    (click)="addServiceRow()"
    [disabled]="eventEdit"
    [hidden]="pastEvent || beforeSaveServ"
  >
    <img id="addAttachicon" alt="icon-add" src="assets/images/icons/purple_icons/icon-add-dark.png" />
    <span name="addServ">Add Service Line</span>
  </button>
  <button mat-flat-button name="exceldwnload" style="float: right">
    <app-excel-download
      [dataSource]="excel_dataDownload"
      [eventId]="eventId"
      [fileName]="'ServiceLine'"
      [columnNames]="excel_columns"
    ></app-excel-download>
  </button>
</div>
<div>
  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    aria-describedby="myservtabledesc"
    aria-describedby="myservtabledesc"
    class="mainTable"
  >
    <ng-container matColumnDef="{{ column }}" *ngFor="let column of columnsToDisplay; let ind = index">
      <th mat-header-cell id="header-{{ column }}" *matHeaderCellDef>
        <span *ngIf="column !== 'editBtns'">{{ column }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let element; let j = dataIndex"
        id="clmn-{{ column }}{{ j }}"
        (click)="setExpandedElement(element, column)"
        [ngClass]="{ expanColor: !element.isEditable && expandedElement == element }"
      >
        <ng-container *ngIf="column === 'Skills'">
          <span *ngIf="element.isEditable">
            <mat-form-field class="custom-form-field">
              <input
                matInput
                placeholder="Service line"
                [matAutocomplete]="autoServiceLine"
                [formControl]="getControl(j, 'skills', 'serviceTable')"
                (keyup)="onTypeServiceLine($event)"
                id="slInput"
                #stickServiceLine
              />
              <mat-autocomplete
                #autoServiceLine="matAutocomplete"
                (optionSelected)="addServiceLine($event.option.value)"
              >
                <mat-option *ngFor="let serviceLine of serviceLineListFiltered; let ie = index" [value]="serviceLine">
                  <span id="slValue-{{ ie }}">{{ serviceLine }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span
            *ngIf="!element.isEditable"
            (click)="navigateTo(null, element, 'serviceLine')"
            style="cursor: pointer"
            [ngClass]="{ 'active-btn': expandedElement != element }"
          >
            {{ element[columnObjectMapper[column]] }}
          </span>
        </ng-container>

        <ng-container *ngIf="column === 'editBtns'">
          <span *ngIf="element['isEditable']">
            <span (click)="addService(element, j)" style="cursor: pointer">
              <img id="updateImg" src="assets/images/icons/default_icons/icon-tick-dark.png" alt="icon-tick" />
            </span>
            <span (click)="removeService(element, j)" style="cursor: pointer">
              <img id="closeImg" src="assets/images/icons/default_icons/icon-close.png" alt="icon-close" />
            </span>
          </span>
          <span *ngIf="expandedElement == element && !element['isEditable']">
            <span (click)="deleteService(element, j)" style="cursor: pointer" [hidden]="pastEvent">
              <img id="deleteServImg" src="assets/images/icons/white_icons/icon-delete-mini.png" alt="icon-delete" />
            </span>
            <span>
              <img
                id="iconCollapse"
                src="assets/images/icons/white_icons/icon-collapse-arrow.png"
                alt="icon-collapse"
              />
            </span>
          </span>
          <span *ngIf="expandedElement !== element && !element['isEditable']">
            <span (click)="deleteService(element, j)" style="cursor: pointer" [hidden]="pastEvent">
              <img id="deleteServImg" src="assets/images/icons/default_icons/icon-delete-mini.png" alt="icon-delete" />
            </span>
            <span>
              <img id="iconExpand" src="assets/images/icons/default_icons/icon-expand-arrow.png" alt="icon-collapse" />
            </span>
          </span>
        </ng-container>
        <ng-container *ngIf="column !== 'Skills' && column !== 'editBtns'">
          {{ element[columnObjectMapper[column]] }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td
        class="nopadLR"
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="columnsToDisplay.length"
        style="padding: 0px !important"
      >
        <span id="scrollPoint"></span>
        <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" *ngIf="!element.isEditable">
          <div class="padTB8" [hidden]="pastEvent || beforeSaveServ">
            <button
              mat-flat-button
              name="addSkil"
              class="Icon-Btn"
              (click)="addSkillRow()"
              [disabled]="eventEdit"
              id="addAtchicon_btn"
            >
              <img id="addAtchicon" alt="icon-add" src="assets/images/icons/purple_icons/icon-add-dark.png" />
              <span name="addSkl">Add Skill</span>
            </button>
          </div>
          <div>
            <table
              mat-table
              [dataSource]="dataSource1"
              aria-describedby="myskilltabledesc"
              aria-describedby="myskilltabledesc"
              multiTemplateDataRows
            >
              <span *ngFor="let column of columnsToDisplay">
                <th mat-header-cell id="headerMini-{{ column }}" *matHeaderCellDef></th>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Min Exp'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    [attr.colspan]="element2.isEditable ? 2 : 0"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2.isEditable">
                      <mat-form-field class="custom-form-field" style="padding-bottom: 5px">
                        <mat-label id="label-minExperience"> Min Exp </mat-label>
                        <mat-select
                          [formControl]="getControl(indx, 'minExperience', 'skillsTable')"
                          #minExp
                          (selectionChange)="changeMaxExp($event.value)"
                          id="minExpValue"
                        >
                          <div id="selectMinExp">
                            <mat-option
                              *ngFor="let exp of experienceDropDown; let index = index"
                              [value]="exp"
                              id="minExpValues-{{ index }}"
                            >
                              {{ exp }}
                            </mat-option>
                          </div>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span *ngIf="!element2.isEditable">
                      {{ element2[columnObjectMapper[column]] }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Max Exp'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    [attr.colspan]="element2.isEditable ? 2 : 0"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2.isEditable">
                      <mat-form-field class="custom-form-field" style="padding-bottom: 5px">
                        <mat-label id="label-maxExperience"> Max Exp </mat-label>
                        <mat-select
                          [formControl]="getControl(indx, 'maxExperience', 'skillsTable')"
                          #maxExp
                          id="maxExpValue"
                        >
                          <div id="selectMaxExp">
                            <mat-option
                              *ngFor="let exp of maxExperienceDropDown; let index = index"
                              [value]="exp"
                              id="maxExpValues-{{ index }}"
                            >
                              {{ exp }}
                            </mat-option>
                          </div>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span *ngIf="!element2.isEditable">
                      {{ element2[columnObjectMapper[column]] }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Target'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    [attr.colspan]="element2.isEditable ? 2 : 0"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2.isEditable">
                      <mat-form-field class="custom-form-field">
                        <input
                          type="number"
                          min="0"
                          matInput
                          placeholder="Target"
                          [formControl]="getControl(indx, 'target', 'skillsTable')"
                          [value]="this.selectedEvnetDetails ? this.selectedEvnetDetails.target : ''"
                        />
                      </mat-form-field>
                    </span>
                    <span *ngIf="!element2.isEditable">
                      {{ element2[columnObjectMapper[column]] }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'Start Time'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    [attr.colspan]="element2.isEditable ? 2 : 0"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2.isEditable || element2.afterSaveEdit">
                      <mat-form-field class="custom-form-field" style="padding-bottom: 5px">
                        <mat-label id="label-startTime"> Start Time </mat-label>
                        <mat-select
                          [formControl]="getControl(indx, 'slotStartTime', 'skillsTable')"
                          #stTime
                          id="startTime"
                          (selectionChange)="setNoOfSlots($event.value, indx)"
                        >
                          <div id="selectStTime">
                            <mat-option
                              *ngFor="let stTime of startTimeDropDown; let index = index"
                              [value]="stTime.slotTime"
                              id="stTimeValues-{{ index }}"
                            >
                              {{ stTime.slotTime }}
                            </mat-option>
                          </div>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span *ngIf="!element2.isEditable && !element2.afterSaveEdit">
                      {{ element2[columnObjectMapper[column]] }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'No of Slots'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    [attr.colspan]="element2.isEditable ? 2 : 0"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2.isEditable || element2.afterSaveEdit">
                      <mat-form-field class="custom-form-field" style="padding-bottom: 5px">
                        <mat-label id="label-slotNum"> No of Slots </mat-label>
                        <mat-select [formControl]="getControl(indx, 'noOfSlots', 'skillsTable')" #slots id="slots">
                          <div id="selectStTime">
                            <mat-option
                              *ngFor="let slotNo of slotsDropDown; let index = index"
                              [value]="slotNo"
                              id="slotNoValues-{{ index }}"
                            >
                              {{ slotNo }}
                            </mat-option>
                          </div>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span *ngIf="!element2.isEditable && !element2.afterSaveEdit">
                      {{ element2[columnObjectMapper[column]] }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="{{ column }}" *ngIf="column === 'editBtns'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    id="colmn-{{ indx }}{{ column }}"
                  >
                    <span *ngIf="element2['isEditable'] || element2.afterSaveEdit">
                      <span (click)="addSkill(element2, indx)" style="cursor: pointer">
                        <img
                          id="skillupdateImg"
                          src="assets/images/icons/default_icons/icon-tick-dark.png"
                          alt="icon-tick"
                        />
                      </span>
                      <span (click)="removeSkill(element2, indx)" style="cursor: pointer">
                        <img
                          id="skillcloseImg"
                          src="assets/images/icons/default_icons/icon-close.png"
                          alt="icon-close"
                        />
                      </span>
                    </span>
                    <span *ngIf="!element2['isEditable'] && !element2.afterSaveEdit" [hidden]="pastEvent">
                      <span (click)="editSkills(element2, indx)" style="cursor: pointer">
                        <img id="editImg" src="assets/images/icons/default_icons/icon-edit.png" alt="icon-edit" />
                      </span>
                      <span (click)="deleteSkill(element2, indx)" style="cursor: pointer">
                        <img
                          id="deleteSkillImg"
                          src="assets/images/icons/default_icons/icon-delete-mini.png"
                          alt="icon-delete"
                        />
                      </span>
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Skills" *ngIf="column === 'Skills'">
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    id="Emptycolmn-{{ indx }}{{ column }}"
                    [attr.colspan]="element2.isEditable ? 4 : 3"
                  >
                    <span *ngIf="element2.isEditable">
                      <mat-form-field class="custom-form-field">
                        <mat-chip-grid #chipList aria-label="Chips selection">
                          <mat-chip-row
                            *ngFor="let chip of chips; let i = index"
                            (removed)="remove(chip)"
                            id="{{ chip.value }}{{ i }}"
                            class="skillChipEvent"
                          >
                            {{ chip.value }}
                            <mat-icon matChipRemove (click)="remove(chip)">cancel</mat-icon>
                          </mat-chip-row>
                          <input
                            placeholder="Skills"
                            #chipInput
                            [formControl]="skillFormCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            #trigger="matAutocompleteTrigger"
                            (keydown.enter)="$event.target.blur(); trigger.closePanel()"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="add($event)"
                            [name]="skills"
                            (keyup)="onTypegetSkill($event)"
                          />
                        </mat-chip-grid>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addSelectedSkill($event)">
                          <div>
                            <mat-option *ngFor="let chip of skills" [id]="chip.skill_name" [value]="chip.skill_name">
                              <span [matTooltip]="setValueInTooltip(chip.skill_name)">
                                {{ chip.skill_name }}
                              </span>
                            </mat-option>
                          </div>
                        </mat-autocomplete>
                      </mat-form-field>
                    </span>
                  </td>
                </ng-container>

                <ng-container
                  matColumnDef="{{ column }}"
                  *ngIf="
                    column !== 'Skills' &&
                    column !== 'Min Exp' &&
                    column !== 'Max Exp' &&
                    column !== 'Target' &&
                    column !== 'Start Time' &&
                    column !== 'No of Slots' &&
                    column !== 'editBtns'
                  "
                >
                  <td
                    mat-cell
                    *matCellDef="let element2; let indx = dataIndex"
                    style="border-bottom: 1px solid gainsboro"
                    id="colmn-{{ indx }}{{ column }}"
                    [hidden]="element2.isEditable"
                  >
                    {{ element2[columnObjectMapper[column]] }}
                  </td>
                </ng-container>
              </span>

              <ng-container matColumnDef="UnitSkills">
                <td
                  mat-cell
                  *matCellDef="let element2; let indx = dataIndex"
                  id="SkillName-{{ indx }}Skill"
                  [attr.colspan]="columnsToDisplay.length"
                >
                  <span
                    *ngIf="!element2.isEditable"
                    (click)="navigateTo(element2, element, 'skillsLine')"
                    class="active-btn"
                    style="cursor: pointer"
                  >
                    {{ element2[columnObjectMapper['Skills']] }}
                  </span>
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: ['UnitSkills']" [hidden]="row.isEditable"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns1"></tr>
            </table>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplay"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>
